export default "__VITE_ASSET__eb8275d7__"